export class FavoriteAlreadyExists extends Error {
  constructor() {
    super('Nome para procedimento cirúrgico favoritado já existe')
    this.name = 'FavoriteAlreadyExists'
  }
}
